import {
  collection,
  selection,
  composeReducers,
} from 'common/store/reducer';

import {
  NAMESPACE,
  SHOW_CREATE_JOB_DIALOG,
  DUPLICATE_JOB_CHECK,
  DUPLICATE_JOB_CHECK_SUCCESS,
  DUPLICATE_JOB_CHECK_ERROR,
  RESET_DUPLICATE_JOB_CHECK,
  SAVE_STEP1_DETAILS,
  CHECK_FOR_METER_EXISTENCE_SUCCESS,
  CHECK_FOR_METER_EXISTENCE_ERROR,
  RESET_METER_EXISTENCE_CHECK,
  SAVE_STEP2_DETAILS,
  RESET_STEP2_DETAILS,
  SAVE_STEP3_DETAILS,
  RESET_STEP3_DETAILS,
  SAVE_STEP4_DETAILS,
  SHOW_PREVIEW_JOB_DIALOG,
} from './actions';

const initial = {
  ...collection.defaultSort('jobId'),
  createJob:{
    pending: false,
    error: null,
    showDialog: false,
    isJobDuplicate: null,
    // job details - step 1
    jobName: "",
    jobType: null,
    isCallBackEnabled: false,
    jobMeterCallback: false,
    jobCallback: false,
    jobCallbackUrl: "",
    // select meters - step 2
    isMeterInvalid: false,
    selectedGroupOrMeters: null,
    // select meters - step 3
    configAction: "get",
    cmdType: null,
    // schedule job for GET - step 4
    isActive: true,
    timeout: null,
    showPreviewDialog: false,
  },
};

const showCreateJobDialog = (state, {flag}) => ({
  ...state,
  createJob:flag === true ?{
    ...state.createJob,
    error: null,
    showDialog: flag,
    isJobDuplicate: null
  }
  :
  {
    // job details - step 1
    ...state.createJob,    configAction: "get",

    error: null,
    showDialog: flag,
    isJobDuplicate: null,
    jobName: "",
    jobType: null,
    isCallBackEnabled: false,
    jobMeterCallback: false,
    jobCallback: false,
    jobCallbackUrl: "",
    // select meters - step 2
    isMeterInvalid: false,
    selectedGroupOrMeters: null,
    // select meters - step 3
    configAction: "get",
    cmdType: null,
    // schedule job for GET - step 4
    isActive: true,
    timeout: null,
  }
});

const duplicateJobCheck = (state, {jobName}) => ({
  ...state,
  createJob:{
    ...state.createJob,
    jobName
  }
});

const duplicateJobCheckSuccess = (state, {response}) => ({
...state,
  createJob:{
    ...state.createJob,
    isJobDuplicate: response.jobName.toLowerCase() === state.createJob.jobName.toLowerCase() ? true : null,
    error: "Job name already exits."
  }
});

const duplicateJobCheckError = (state, {error}) => ({
...state,
  createJob:{
    ...state.createJob,
    isJobDuplicate: error.status === 404 ? null : true,
    error: null
  }
});

const resetDuplicateJobCheck =  (state) => ({
...state,
  createJob:{
    ...state.createJob,
    jobName: "",
    isJobDuplicate: null,
    error: null
  }
});

const saveStep1Details = (state, {jobDetails}) => ({
  ...state,
  createJob: {
    ...state.createJob,
    ...jobDetails
  }
});

export const checkForMeterExistenceSuccess = (state, {response}) => ({
  ...state,
});

const checkForMeterExistenceError = (state, {error}) => ({
  ...state,
  createJob:{
    ...state.createJob,
    isMeterInvalid: error.status === 400 ? true : null,
    error: error.response.message
  }
});

const resetMeterExistenceCheck = (state, {response}) => ({
  ...state,
  createJob:{
    ...state.createJob,
    isMeterInvalid: null,
    error: null,
  }
});

const saveStep2Details = (state, {details}) => ({
  ...state,
  createJob: {
    ...state.createJob,
    selectedGroupOrMeters: details,
  }
});

const resetstep2Details = (state, {details}) => ({
  ...state,
  createJob: {
    ...state.createJob,
    selectedGroupOrMeters: null,
  }
});

const saveStep3Details = (state, {details}) => ({
  ...state,
  createJob: {
    ...state.createJob,
    ...details,
  }
});

const resetstep3Details = (state, {details}) => ({
  ...state,
  createJob: {
    ...state.createJob,
    configAction: "get",
    cmdType: null
  }
});

const saveStep4Details = (state, {details}) => ({
  ...state,
  createJob: {
    ...state.createJob,
    ...details,
  }
});

export const showPreviewJobDialog = (state, {flag}) => ({
  ...state,
  showPreviewDialog: flag,
});

const collectionReducer = (state = initial, action) => {
  const reducer = {
    [SHOW_CREATE_JOB_DIALOG]: showCreateJobDialog,
    [DUPLICATE_JOB_CHECK]: duplicateJobCheck,
    [DUPLICATE_JOB_CHECK_SUCCESS]: duplicateJobCheckSuccess,
    [DUPLICATE_JOB_CHECK_ERROR]: duplicateJobCheckError,
    [RESET_DUPLICATE_JOB_CHECK]: resetDuplicateJobCheck,
    [SAVE_STEP1_DETAILS]: saveStep1Details,
    [CHECK_FOR_METER_EXISTENCE_SUCCESS]: checkForMeterExistenceSuccess,
    [CHECK_FOR_METER_EXISTENCE_ERROR]: checkForMeterExistenceError,
    [RESET_METER_EXISTENCE_CHECK]: resetMeterExistenceCheck,
    [SAVE_STEP2_DETAILS]: saveStep2Details,
    [RESET_STEP2_DETAILS]: resetstep2Details,
    [SAVE_STEP3_DETAILS]: saveStep3Details,
    [RESET_STEP3_DETAILS]: resetstep3Details,
    [SAVE_STEP4_DETAILS]: saveStep4Details,
    [SHOW_PREVIEW_JOB_DIALOG]: showPreviewJobDialog,
  }[action.type];

  return reducer ? reducer(state, action) : state;
};

export default composeReducers(
  collection.factory(NAMESPACE),
  selection.factory(NAMESPACE),
  collectionReducer,
  (state = initial) => state,
);
